angular.module('storefrontApp')
    .component('rsCarouselMobile', {
        templateUrl: 'themes/assets/js/common-components/rsCarouselMobile.tpl.html.liquid',
        bindings: {
            placeHolderName: '@',
        },
        controller: ['$scope', 'rsCarouselService', '$timeout', '$window',
            function ($scope, rsCarouselService, timeoutService, $window) {
                const ctrl = this;

                let $carousel;

                // 2.2.2: a visitor with the OS "reduce motion" preference gets no
                // autoplay at all; the pause/play control can still start it.
                const prefersReducedMotion = $window.matchMedia('(prefers-reduced-motion: reduce)').matches;

                ctrl.autoplayPaused = prefersReducedMotion;

                ctrl.toggleAutoplay = () => {
                    ctrl.autoplayPaused = !ctrl.autoplayPaused;
                    if (ctrl.autoplayPaused) {
                        $carousel.slick('slickPause');
                    } else {
                        $carousel.slick('slickPlay');
                    }
                };

                this.$onInit = () => {
                    rsCarouselService.get(ctrl.placeHolderName)
                        .then((response) => {
                            ctrl.images = response.data.map((item) => ({
                                ...item,
                                textAlignment: item.textAlignment || 'Center',
                            }));

                            timeoutService(() => {
                                $carousel = angular.element('.slick-rs-carousel-mobile');

                                function fixSlickAria() {
                                // Slick incorrectly uses tab ARIA roles on a carousel.
                                // Replace with correct carousel semantics.
                                    $carousel.find('.slick-dots').removeAttr('role');
                                    $carousel.find('.slick-dots li').each(function () {
                                        const $item = angular.element(this);
                                        const $button = $item.find('button');
                                        $item.removeAttr('role');
                                        $button.attr('role', 'button').removeAttr('aria-selected');
                                        if ($item.hasClass('slick-active')) {
                                            $button.attr('aria-current', 'true');
                                        } else {
                                            $button.removeAttr('aria-current');
                                        }
                                    });
                                    $carousel.find('.slick-slide').removeAttr('role');
                                }

                                // autoplay is decided here, not in data-slick: slick merges
                                // data-slick options OVER call-time settings, and the
                                // reduced-motion preference is runtime state.
                                $carousel.slick({ autoplay: !prefersReducedMotion });

                                // Slick re-applies its tab-role ARIA after every slide change
                                // (postSlide -> initADA) and fires afterChange BEFORE initADA,
                                // so no event handler can correct it. Hook the instance instead;
                                // init, postSlide and refresh all funnel through initADA.
                                const slick = $carousel.slick('getSlick');
                                const initADA = slick.initADA.bind(slick);
                                slick.initADA = () => {
                                    initADA();
                                    fixSlickAria();
                                };
                                fixSlickAria();
                            }, 0, false);
                        });
                };
            }],
    });
